<template>
  <div class="table-container-page display-col full-height">
    <div class="lx-flex-shrink-0 lx-flex-row-between" v-if="showBreadCrumb=='1'&&canReturn=='0'">
      <BreadCrumb />
      <div style="margin-bottom:10px">
        <a target="_blank"
           href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/zhaoke/yuzaiko/%E5%9B%BD%E9%9A%9B%E9%80%81%E6%96%99202406.%E6%9B%B4%E6%96%B0.docx"
           style="margin-right:20px">{{$t('excel.excel15')}}</a>
        <a target="_blank"
          href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/zhaoke/yuzaiko/昭可贸易检品收费标准2024.docx"
          style="margin-right:20px">{{$t('excel.excel16')}}</a>
        <a target="_blank"
          href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/zhaoke/yuzaiko/充值送金活动.docx">{{$t('excel.excel17')}}</a>
      </div>
    </div>
    <div class="breadcrumb-container editBread-container" v-if="showBreadCrumb=='1'&&canReturn=='1'">
      <slot name="editBreadcrumb"></slot>
    </div>

    <div class="search-container">
      <slot name="search"></slot>
    </div>
    <div class="table-container flex1 lx-flex-column lx-hidden">
      <slot name="table"></slot>
    </div>
  </div>
</template>

<script>
import BreadCrumb from './layout/components/breadCrumb'
export default {
  data () {
    return {

    }
  },
  props: {
    canReturn: {
      default: '0'
    },
    showBreadCrumb: {
      default: '1'
    }
  },
  components: { BreadCrumb },
  methods: {

  },
  created () {
  }
};
</script>

<style lang="less" scoped>
a {
  color: black;
  text-decoration: none;
}
// .table-container-page {
//   // overflow: auto;
// }
.editBread-container {
  padding-bottom: 10px;
}
.search-container {
  // height: 120px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
.table-container {
  margin-top: 10px;
  overflow: hidden;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
.breadcrumb {
  display: flex;
  justify-content: space-between;
}
</style>
